import React from "react";
import { Stack } from "@mui/system";
import { Paper, Typography, Badge } from "@mui/material";
import { StoreItem } from "../../../../../../../domain/models/storage-item";
import DeleteIcon from "@mui/icons-material/Delete";

type Props = {
  item: StoreItem;
  onDelete?: (item: StoreItem) => void;
};

export const StoreItemCard: React.FC<Props> = ({ item, onDelete }) => {
  return (
    <Badge
      badgeContent={<DeleteIcon />}
      color="error"
      sx={{
        "& .MuiBadge-badge": {
          height: "40px",
          width: "40px",
          borderRadius: "50%",
        },
      }}
      onClick={onDelete?.bind(null, item)}
    >
      <Paper sx={{ padding: "20px" }}>
        <Stack spacing={2}>
          <Typography fontWeight="bold" fontSize="24px">
            {item.description}
          </Typography>
          <Typography>{`Fornecedor: ${item.supplier}`}</Typography>
          {item.batchControl && (
            <Typography>{`Lote: ${item.batch}`}</Typography>
          )}
          <Typography>{`Quantidade: ${item.amount}`}</Typography>
        </Stack>
      </Paper>
    </Badge>
  );
};
